import {Injectable} from '@angular/core';
import {Observable, map} from 'rxjs';
import {ApiConfig} from '../../../shared/services/api/config.api';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApiResponse} from '../../../shared/types/api-response.type'
import {GENERAL_CONSTANTS} from '../../../shared/constants/constant';
import {SERVICE_CONSTANTS, API_CONSTANTS} from '../../../shared/constants/apiConstant';
import {PensionCalculatorRequest} from '../../../shared/types/pension-calculator.type';

@Injectable({ providedIn: 'root' })
export class PensionCalculatorService {
  private readonly baseUrl: string = ApiConfig.baseURL + SERVICE_CONSTANTS.WEB_SERVICE + GENERAL_CONSTANTS.SLASH;

  constructor(private readonly http: HttpClient) {}

  public calculatePensionEmployee(token: string, body: PensionCalculatorRequest): Observable<ApiResponse> {
    const headers = new HttpHeaders({
      Authorization: token
    });

    return this.http.post<ApiResponse>(
      this.baseUrl + API_CONSTANTS.CALCULATOR_CALCULATE, 
      body, 
      { headers: headers }
    ).pipe(map(this.normalizeResponse));
  }
  
  public calculatePension(token: string, body: PensionCalculatorRequest, file: File): Observable<ApiResponse> {
    const headers = new HttpHeaders({
      Authorization: token
    });
    const formData = this.buildMultipartRequest(body, file);

    return this.http.post<ApiResponse>(
      this.baseUrl + API_CONSTANTS.CALCULATOR_CALCULATE_PDKP, 
      formData, 
      { headers: headers }
    ).pipe(map(this.normalizeResponse));
  }

  private buildMultipartRequest(body: PensionCalculatorRequest, file: File): FormData {
    const formData = new FormData();

    formData.append(
      'request',
      new Blob([JSON.stringify(body)], { type: 'application/json' })
    );
    formData.append('file', file);

    return formData;
  }

  private normalizeResponse(response: ApiResponse): ApiResponse {
    return {
      ...response,
      replyMessageList: Array.isArray(response.replyMessageList)
        ? response.replyMessageList
        : []
    };
  }
}
